import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    dashcomponents: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_DASHCOMPONENTS_SELECT_IDS (store, ids) {
      store.dashcomponents.selectIds = ids
    },
    REMOVE_DASHCOMPONENT_SELECT_IDS (store, ids) {
      store.dashcomponents.selectIds = store.dashcomponents.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_DASHCOMPONENTS_SELECT_ID (store, id) {
      store.dashcomponents.selectId = id
    },
    SET_DASHCOMPONENTS_FILTERS (store, filters) {
      store.dashcomponents.filters = filters
    },
    SET_DASHCOMPONENTS_PAGINATE (store, val) {
      store.dashcomponents.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getDashcomponents: (store, getters) => {
      return store.dashcomponents.selectIds.map((id) => {
        return getters['entities/dashcomponents/find'](id)
      })
    },
    getDashcomponentsFilters: (store, getters) => {
      return store.dashcomponents.filters
    },
    getDashcomponentsPaginate: (store, getters) => {
      return store.dashcomponents.paginate
    },
    getDashcomponent: (store, getters) => {
      return getters['entities/dashcomponents/find'](store.dashcomponents.selectId) || {}
    }
  },
  actions: {
    /*
    selectDashcomponents
    */
    selectDashcomponents ({commit, dispatch, getters, state}, filters) {
      return dispatch('getDashcomponents', filters)
      .then((response) => {
        commit('SET_DASHCOMPONENTS_FILTERS', filters)
        commit('SET_DASHCOMPONENTS_PAGINATE', response)
        commit('SET_DASHCOMPONENTS_SELECT_IDS', response.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectDashcomponents
    */
    refreshSelectDashcomponents ({commit, dispatch, getters, state}) {
      return dispatch('selectDashcomponents', getters.getDashcomponentsFilters)
    },
    /*
    selectDashcomponent
    */
    selectDashcomponent ({commit, dispatch, getters, state}, id) {
      return dispatch('getDashcomponentById', id)
      .then((response) => {
        commit('SET_DASHCOMPONENTS_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getDashcomponents
    */
    getDashcomponents ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/dashboards/${filters.dashboard_id}/dashcomponents`, {params: filters})
      .then((response) => {
        return dispatch('entities/dashcomponents/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.dashcomponents || []
      })
    },
    /*
    getDashcomponentById
    */
    getDashcomponentById ({commit, dispatch, getters, state}, params) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/dashboards/${params.dashboard_id}/dashcomponents/${params.id}`)
      .then((response) => {
        return dispatch('entities/dashcomponents/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.dashcomponents[0]
      })
    },
    /*
    createDashcomponent
    */
    createDashcomponent ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/dashboards/${data.dashboard_id}/dashcomponents`, data)
      .then((response) => {
        return dispatch('entities/dashcomponents/insert', {
          data: response.data
        })
      })
      .then((response) => {
        dispatch('changeDashcomponent')
        return response.dashcomponents[0]
      })
    },
    /*
    updateDashcomponent
    */
    updateDashcomponent ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/dashboards/${data.dashboard_id}/dashcomponents/${data._id}`, data)
      .then((response) => {
        return dispatch('entities/dashcomponents/insert', {
          data: response.data
        })
      })
      .then((response) => {
        dispatch('changeDashcomponent')
        return response.dashcomponents[0]
      })
    },
    /*
    sortDashcomponent
    */
    sortDashcomponent ({commit, dispatch, getters, state}, data) {
      return Promise.all(data.map(item => {
        return axios.put(`/accounts/${getters.getAccount._id}/dashboards/${item.dashboard_id}/dashcomponents/${item._id}`, {
          position: item.position
        })
        .then((response) => {
          return dispatch('entities/dashcomponents/insert', {
            data: response.data
          })
        })
      }))
      .then((response) => {
        dispatch('changeDashcomponent')
        return response
      })
    },
    /*
    deleteDashcomponent
    */
    deleteDashcomponent ({commit, dispatch, getters, state}, params) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/dashboards/${params.dashboard_id}/dashcomponents/${params.id}`)
      .then((response) => {
        commit('REMOVE_DASHCOMPONENT_SELECT_IDS', [params.id])
        dispatch('entities/dashcomponents/delete', params.id)
        dispatch('changeDashcomponent')
        return {}
      })
    },
    /*
    changeDashcomponent
    */
    changeDashcomponent ({commit, dispatch, getters, state}, params) {
      dispatch('refreshSelectDashboards')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Dashcomponent.js